<template>
	<div class="app-version">
		<search-app-version
			v-on:onSubmit="onSubmit"
			v-on:addAppVersion="addAppVersion"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-app-version>
		<add-app-version
			:dialogAppVersion="dialogAppVersion"
			:appVersion="appVersion"
			:appTypeList="appTypeList"
			v-on:cancel="cancel"
		>
		</add-app-version>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="appVersionList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="appType"
					:label="$t('appVersion.appType')"
					:formatter="appType"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="appName"
					:label="$t('appVersion.appName')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					:label="$t('appVersion.icon')"
					width="100"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-image
							style="width: 60px;height: 60px"
							:src="scope.row.image"
							fit="fill"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="appVersionBefore"
					:label="$t('appVersion.appVersionBefore')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="appVersion"
					:label="$t('appVersion.appVersion')"
					width="110"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="notes"
					:show-overflow-tooltip="true"
					:label="$t('appVersion.notes')"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('appVersion.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					width="100"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['sys:app:version:update']"
							@click="editAppVersion(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<!--<el-button type="danger" size="mini" @click="delMachine(scope.row)">删除</el-button>-->
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import searchAppVersion from "_c/system/app/SearchAppVersion";
import addAppVersion from "_c/system/app/AddAppVersion";
export default {
	name: "AppVersion",
	components: {
		searchAppVersion,
		addAppVersion,
	},
	data() {
		return {
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				appName: "",
			},
			loading: false,
			appVersionList: [],
			appTypeList: [],
			dialogAppVersion: false,
			appVersion: {
				id: "",
				appType: "",
				appVersion: "",
				appVersionBefore: "",
				appImage: "",
				appName: "",
				downUrl: "",
			},
		};
	},
	mounted() {
		this.currentChange();
		this.listAppType();
	},
	methods: {
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.AppVersion.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.appVersionList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		listAppType() {
			this.$api.dict("sys_app_type").then(res => {
				if (res.code === 0) {
					this.appTypeList = res.data;
				}
			});
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		addAppVersion() {
			this.dialogAppVersion = true;
		},
		appType(row) {
			return this.$cloud.getDictLabel(this.appTypeList, row.appType);
		},
		cancel(dialog, state) {
			this.dialogAppVersion = dialog;
			if (state) {
				this.currentChange();
			}
		},
		editAppVersion(row) {
			this.dialogAppVersion = true;
			Object.keys(this.appVersion).forEach(key => {
				this.appVersion[key] = row[key];
			});
			this.appVersion.id = row.id;
		},
	},
};
</script>

<style lang="scss"></style>
